
import React from "react";
import { getCurrentUser } from "../../lib/auth_base/localstorage";
import Header from "../../components/header/header";

export default function AdminTop() {

  const tog: any[] = [];
  const togMore = (index: number) => {
    if (!tog[index]) {
      tog[index] = true;
    } else {
      tog[index] = !tog[index];
    }
    console.log(tog);
  };
  const user = getCurrentUser();
  return (
    <React.Fragment>
      <div className={`page-top-mini`}>
        <div className={`page-overlay-beige`}></div>
        <Header is_home={false} is_logged={user ? true:false} />
      </div>
    </React.Fragment>
  );
}